import { Tooltip, type TooltipProps } from "@mui/material";
import { useState } from "react";

export const InHouseTooltip = ({ children, onOpen, onClose, ...props }: TooltipProps) => {
	const [open, setOpen] = useState(false);

	return (
		<Tooltip
			{...props}
			open={open}
			onOpen={(event) => {
				setOpen(true);
				onOpen?.(event);
			}}
			onClose={(event) => {
				setOpen(false);
				onClose?.(event);
			}}
		>
			{children}
		</Tooltip>
	);
};
